import React, { useState, useContext } from 'react';
import UserContext from '../context/UserContext';
import axios from '../api/client';
import { requestPrivacyExport, requestAccountErasure } from '../api/privacy';
import { GoogleLogin } from '@react-oauth/google';
import '../Login.css';
import seePass from '../images/seePassword.png';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams,
  navigate,
  useLocation,
  Navigate,
  useNavigate,
  NavLink
} from "react-router-dom";

const AccountPage = () => {
  const { user, setUser, isLoggedIn, logout } = useContext(UserContext);
  const navigateTo = useNavigate();
  
  const [newUsername, setNewUsername] = useState(user?.username || ''); // Add null check here
  const [newEmail, setNewEmail] = useState(user?.email || ''); // Add null check here
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordC, setShowPasswordC] = useState(false);
  const [image, setImage] = useState(null);
  const [displayName, setDisplayName] = useState(user?.displayName || '');
  const [pronouns, setPronouns] = useState(user?.pronouns || '');
  const [bio, setBio] = useState(user?.bio || '');
  const [pfp, setPfp] = useState(null);
  const [selectedPronoun, setSelectedPronoun] = useState(user?.pronouns || '');
  
 
  const [customPronoun, setCustomPronoun] = useState('');
  const [privacyPassword, setPrivacyPassword] = useState('');
  const [privacyCredential, setPrivacyCredential] = useState('');
  const [privacyBusy, setPrivacyBusy] = useState('');
  const [privacyMessage, setPrivacyMessage] = useState('');
  const [confirmErasure, setConfirmErasure] = useState(false);
  const [earningsEmailEnabled, setEarningsEmailEnabled] = useState(Boolean(user?.earningsEmailEnabled));
  const [notificationPreferenceBusy, setNotificationPreferenceBusy] = useState(false);
  const [notificationPreferenceMessage, setNotificationPreferenceMessage] = useState('');
  const isGoogleAccount = Boolean(user?.usesgoogle || user?.usesGoogle || user?.google_subject);

  const privacyReauth = () => isGoogleAccount
    ? { credential: privacyCredential }
    : { password: privacyPassword };

  const describePrivacyError = (error) => {
    const code = error.response?.data?.code;
    if (code === 'REAUTH_REQUIRED' || error.response?.status === 401) return 'Please verify your identity again.';
    if (error.response?.status === 429) return 'Too many requests. Please wait and try again.';
    if (error.response?.status === 503) return 'Privacy requests are temporarily unavailable.';
    return error.response?.data?.error || 'The request could not be completed. Please try again.';
  };

  const handlePrivacyExport = async () => {
    setPrivacyBusy('export'); setPrivacyMessage('');
    try {
      const result = await requestPrivacyExport(privacyReauth());
      if (result.pending) {
        setPrivacyMessage(`Export request received${result.requestId ? ` (${result.requestId})` : ''}. It requires verified support delivery.`);
      } else {
        const url = URL.createObjectURL(result.blob);
        const anchor = document.createElement('a');
        anchor.href = url; anchor.download = result.filename; document.body.appendChild(anchor); anchor.click(); anchor.remove();
        URL.revokeObjectURL(url);
        setPrivacyMessage('Your StockSleuth data export was downloaded.');
      }
    } catch (error) { setPrivacyMessage(describePrivacyError(error)); }
    finally { setPrivacyBusy(''); }
  };

  const handleAccountErasure = async () => {
    if (!confirmErasure) return setPrivacyMessage('Confirm that you understand the account will be permanently erased.');
    setPrivacyBusy('delete'); setPrivacyMessage('');
    try {
      const result = await requestAccountErasure(privacyReauth());
      logout();
      setUser(null);
      navigateTo('/SignIn', { replace: true, state: { accountErasurePending: true, requestId: result.requestId } });
    } catch (error) { setPrivacyMessage(describePrivacyError(error)); setPrivacyBusy(''); }
  };

  const handleSignOut = async () => {
    try {
      await axios.post('/auth/logout');
    } catch {
      // Local logout must still complete if the backend is unavailable.
    } finally {
      logout();
      navigateTo('/SignIn', { replace: true });
    }
  };

  const handleNotificationPreference = async () => {
    setNotificationPreferenceBusy(true);
    setNotificationPreferenceMessage('');
    try {
      const response = await axios.post('/auth/update-preferences', { earningsEmailEnabled });
      if (response.data?.updatedUser) {
        setUser((current) => ({ ...current, ...response.data.updatedUser, earningsEmailEnabled: Boolean(response.data.updatedUser.earningsEmailEnabled) }));
      }
      setNotificationPreferenceMessage('Email preference saved.');
    } catch (error) {
      setNotificationPreferenceMessage(error.response?.data?.message || 'Could not save the email preference.');
    } finally {
      setNotificationPreferenceBusy(false);
    }
  };
  
  console.log(user?.pronouns);
  const handleUpdateAccount = async () => {
    try {
      const formData = new FormData();
      formData.append('username', user.username);
      formData.append('displayName', displayName);
      formData.append('pronouns', pronouns);
      formData.append('bio', bio);
      formData.append('pfp', image);

      const response = await axios.post('https://stocksleuth.xyz:5000/auth/update', formData);

      setUser(response.data.updatedUser);
      console.log('Account updated successfully:', response.data);
      ///
      window.location.reload();
    } catch (error) {
      console.error('Account update failed', error);
    }
  };
	
	
	const handleImageChange = (e) => {
    const file = e.target.files[0];
  
    if (file) {
      const reader = new FileReader();
  
      reader.onload = async (e) => {
        const img = new Image();
        img.src = e.target.result;
  
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
  
          // Set the canvas dimensions to your desired size
          const desiredWidth = 256;
          const desiredHeight = 256;
  
          // Calculate the aspect ratio of the image
          const aspectRatio = img.width / img.height;
  
          // Calculate the dimensions of the portion to be cropped
          let cropWidth = img.width;
          let cropHeight = img.height;
          let cropX = 0;
          let cropY = 0;
  
          if (aspectRatio > 1) {
            // Landscape-oriented image
            cropWidth = img.height;
            cropHeight = img.height;
            cropX = (img.width - img.height) / 2;
          } else if (aspectRatio < 1) {
            // Portrait-oriented image
            cropWidth = img.width;
            cropHeight = img.width;
            cropY = (img.height - img.width) / 2;
          }
  
          // Set the canvas dimensions to your desired size
          canvas.width = desiredWidth;
          canvas.height = desiredHeight;
  
          // Draw the image on the canvas with the desired size and crop
          ctx.drawImage(img, cropX, cropY, cropWidth, cropHeight, 0, 0, desiredWidth, desiredHeight);
  
          // Convert the canvas content to a Blob object (compressed image file)
          canvas.toBlob((blob) => {
            setImage(blob);
          }, 'image/jpeg', 0.7);
        };
      };
  
      reader.readAsDataURL(file);
    }
  };
  


  const handleChange = (event) => {
    const { value } = event.target;
    setSelectedPronoun(value);
    setPronouns(value)
    if (value == 'other') {
      setPronouns('');
    }
    // Reset customPronoun if another pronoun is selected
    if (value !== 'other') {
      setCustomPronoun('');
    }
  };
  return (
  <div className="AccountPageShell" style={{height: '100vh', width: '100vw ', display: 'flex', alignItems: "center",
			justifyContent: "center",
			textAlign: "center", position: 'absolute', left: '0px'}}>
      {isLoggedIn ? (<>
      
    
  <div className="AccountForm">
    <div className="AccountHeading">Your Profile</div>
    <NavLink to={`/profile/${user?.displayname}`}><div className="see">View Your Profile</div></NavLink>
    <div className="SaveChanges" onClick={handleUpdateAccount}>Save Changes</div>
    <button type="button" className="AccountSignOut" onClick={handleSignOut}>Sign Out</button>
    <section className="AccountNotificationPanel" aria-labelledby="earnings-email-heading">
      <h2 id="earnings-email-heading">Email notifications</h2>
      <label className="settingsCheckboxRow" htmlFor="earnings-email-enabled">
        <input id="earnings-email-enabled" type="checkbox" checked={earningsEmailEnabled} onChange={(event) => setEarningsEmailEnabled(event.target.checked)} />
        <span>
          <strong>Sunday earnings preview</strong>
          <small>Reporting dates, EPS and revenue estimates, and recent earnings for companies in your watchlists and portfolio.</small>
        </span>
      </label>
      <button type="button" onClick={handleNotificationPreference} disabled={notificationPreferenceBusy}>{notificationPreferenceBusy ? 'Saving…' : 'Save email preference'}</button>
      {notificationPreferenceMessage && <p role="status">{notificationPreferenceMessage}</p>}
    </section>
    <details className="AccountPrivacyPanel">
      <summary>Privacy &amp; account data</summary>
      <p>Verify your identity to download your data or request permanent account erasure.</p>
      {isGoogleAccount ? <div className="AccountGoogleReauth"><GoogleLogin onSuccess={(result) => { setPrivacyCredential(result.credential || ''); setPrivacyMessage(result.credential ? 'Google identity verified.' : 'Google verification failed.'); }} onError={() => setPrivacyMessage('Google verification failed.')} /></div> : <input className="AccountPrivacyPassword" type="password" autoComplete="current-password" placeholder="Current password" value={privacyPassword} onChange={(event) => setPrivacyPassword(event.target.value)} />}
      <div className="AccountPrivacyActions">
        <button type="button" disabled={Boolean(privacyBusy) || !(privacyPassword || privacyCredential)} onClick={handlePrivacyExport}>{privacyBusy === 'export' ? 'Preparing…' : 'Download my data'}</button>
        <label><input type="checkbox" checked={confirmErasure} onChange={(event) => setConfirmErasure(event.target.checked)} /> I understand deletion is permanent.</label>
        <button type="button" className="AccountPrivacyDelete" disabled={Boolean(privacyBusy) || !(privacyPassword || privacyCredential) || !confirmErasure} onClick={handleAccountErasure}>{privacyBusy === 'delete' ? 'Submitting…' : 'Delete my account'}</button>
      </div>
      {privacyMessage && <p className="AccountPrivacyMessage" role="status">{privacyMessage}</p>}
      <Link to="/privacy">Read the Privacy Policy</Link>
    </details>
    <div style={{left: 71, position: "absolute", top: "50px"}}>
			<h2 className = "DisName" style = {{margin: "0px", position: 'relative', left: 0, top: 0, textAlign: 'left', paddingBottom: "6px"}}>Username*</h2>
			<div className = "EmailInput">
			<input value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}className="EmailPlaceholder" style={{color: 'black',padding: '0px',position: 'relative',left: '15px', border: 'none', background: 'none' }}type="text" placeholder={user?.displayname || ''}  />
			</div>
      <h2 className="Pronouns" style={{ margin: "0px", position: 'relative', left: 0, top: 0, textAlign: 'left', paddingBottom: "6px", paddingTop: "10px" }}>Pronouns</h2>
      <div className="EmailInput">
        {selectedPronoun === 'other' ? (
          <input
            className="ProPlaceholder"
            style={{ color: 'black', padding: '0px', position: 'relative',left: '15px', border: 'none', background: 'none' }}
            type="text"
            placeholder="Enter custom pronouns"
            value={pronouns}
            onChange={(e) => setPronouns(e.target.value)}
          />
        ) : (
          <select
            className="ProPlaceholder"
            style={{ color: 'black', padding: '0px', position: 'relative', left: "15px", border: 'none', background: 'none' }}
            value={selectedPronoun}
            onChange={handleChange}
            
          >
            {(!user?.pronouns || user?.pronouns === '') && <option value="" disabled>Select pronouns</option>}
            <option value="they/them">They/Them</option>
            <option value="he/him">He/Him</option>
            <option value="she/her">She/Her</option>
            <option value="other">Other</option>
          </select>
        )}
      </div>
      <h2 className = "Bio" style = {{margin: "0px", position: 'relative', left: 0, top: 0, textAlign: 'left', paddingBottom: "6px",paddingTop: "10px"}}>Bio</h2>
			<div className="BioInput" style={{ position: 'relative', padding: '10px', boxSizing: 'border-box' }}>
  <textarea
    value={bio}
    onChange={(e) => setBio(e.target.value)}
    className="bioPlaceholder"
    style={{
      color: 'black',
      padding: '10px', // Ensures 10px inset
      position: 'relative',
      width: '100%',
      height: '100%',
      border: 'none',
      background: 'none',
      resize: 'none', // Prevents resizing
      overflowWrap: 'break-word', // Ensures text wrapping
      boxSizing: 'border-box', // Ensures padding is included in dimensions
      outline: 'none',
    }}
    placeholder={user ? user.bio || '' : ''}
  />
</div>

      
      <div className='pfp'>
      {image ? (
  // Check if image state has a value (image blob)
  <img
    src={URL.createObjectURL(image)} // Use URL.createObjectURL to display the selected image
    alt="pfp"
    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: "8px" }}
  />
) : (
  user && user.profile_image ? (
    <img
      src={`data:image/jpeg;base64,${user.profile_image}`} // Use user.profile_image directly
      alt="pfp"
      style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: "8px" }}
    />
  ) : (
    <></>
  )
)}

  <input
    type="file"
    accept="image/*"
    style={{ position: 'absolute', bottom: 0, right: 0, opacity: 0, cursor: 'pointer', width: '100%', height: '100%', borderRadius: "8px" }}
    onChange={handleImageChange}
  />
</div>
      </div>

    
    </div></>) : (
        <div>
		
        </div>
      )}</div>
  );
};

export default AccountPage;
